import { render, staticRenderFns } from "./PlayerListSubstitute.vue?vue&type=template&id=25f82746&scoped=true"
import script from "./PlayerListSubstitute.vue?vue&type=script&lang=js"
export * from "./PlayerListSubstitute.vue?vue&type=script&lang=js"
import style0 from "./PlayerListSubstitute.vue?vue&type=style&index=0&id=25f82746&prod&scoped=true&lang=css"
import style1 from "./PlayerListSubstitute.vue?vue&type=style&index=1&id=25f82746&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f82746",
  null
  
)

export default component.exports